import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { AdminRoute, UserRoute } from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserDetails from './pages/UserDetails';
import AdminPortal from './pages/AdminPortal';
import DeleteHistory from './pages/DeleteHistory';
import MetalRates from './pages/MetalRates';
import AdminActivity from './pages/AdminActivity';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Routes>
          {/* Public */}
          <Route path="/" element={<Login />} />

          {/* Admin only */}
          <Route path="/dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
          <Route path="/admin" element={<AdminRoute><AdminPortal /></AdminRoute>} />
          <Route path="/delete-history" element={<AdminRoute><DeleteHistory /></AdminRoute>} />
          <Route path="/metal-rates" element={<AdminRoute><MetalRates /></AdminRoute>} />
          <Route path="/admin-activity" element={<AdminRoute><AdminActivity /></AdminRoute>} />

          {/* Admin sees all; user can only see their own */}
          <Route path="/user/:id" element={<UserRoute><UserDetails /></UserRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;